import { purchaseHandle, claimHandle } from '../api/handles'

export type PurchaseAndClaimResult = {
  ok: true
  payment_ref: string
} | {
  ok: false
  deficit_pixe?: number
  detail: string
}

export async function purchaseAndClaimPremium(reservationId: number): Promise<PurchaseAndClaimResult> {
  const resp = await purchaseHandle(reservationId)
  if (resp.deficit_pixe) {
    return { ok: false, deficit_pixe: resp.deficit_pixe, detail: 'insufficient_pixe' }
  }
  if (!resp.payment_ref) {
    return { ok: false, detail: 'missing_payment_ref' }
  }
  await claimHandle(reservationId, resp.payment_ref)
  return { ok: true, payment_ref: resp.payment_ref }
}

